import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-settings-footer',
    templateUrl: './settings-footer.component.html',
    styleUrls: ['./settings-footer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class SettingsFooterComponent {
    @Input() public isSaveDisabled: boolean;
    @Output() public readonly saveEvent = new EventEmitter<void>();
    @Output() public readonly cancelEvent = new EventEmitter<void>();
}
